const clientLoadMoreAll = ({ resultsList, resultItems, withAjax, button }) => {
  resultItems.forEach((item) => item.classList.remove('hidden'));
  resultsList.setAttribute('data-last-index-shown', resultItems.length);
  if (!withAjax) {
    button.classList.add('!hidden', 'lg:!hidden');
  }
};
const clientLoadMoreByIncrement = ({ resultsList, resultItems, withAjax, button, increment, initiallyLoadedItemsCount }) => {
  const lastIndexShown = parseInt(resultsList.getAttribute('data-last-index-shown'));
  const itemsToUpdate = resultItems.splice(lastIndexShown + 1, increment);
  itemsToUpdate.forEach((item) => {
    item.classList.remove('hidden');
  });
  resultsList.setAttribute('data-last-index-shown', lastIndexShown + itemsToUpdate.length);
  if (itemsToUpdate.length >= increment) return;
  // for lists where Ajax could be required, but there are not enough items in database to actually need it
  const willNotNeedAjax = withAjax && initiallyLoadedItemsCount < 20;
  if (!withAjax || willNotNeedAjax) {
    button.classList.add('!hidden');
  }
};

export const clientLoadMore = ({
  button,
  withAjax = false,
  increment,
  listId = 'js-results',
  itemClass = 'js-result-item',
  initiallyLoadedItemsCount = undefined,
}) => {
  const resultsList = document.getElementById(listId);
  const resultItems = Array.from(resultsList.querySelectorAll(`.${itemClass}`));
  if (increment) {
    clientLoadMoreByIncrement({ resultsList, resultItems, withAjax, button, increment, initiallyLoadedItemsCount });
  } else {
    clientLoadMoreAll({ resultsList, resultItems, withAjax, button });
  }
};

const serverLoadMore = (displayedItems) => {
  $.ajax({
    // eslint-disable-next-line no-undef
    url: ajax_object.ajax_url,
    method: 'POST',
    data: { action: 'get_actualites', start_index: displayedItems },
    // eslint-disable-next-line no-undef
    success: (res) => {
      const resultsList = $('#js-results');
      resultsList.append(res);
    },
    // eslint-disable-next-line no-undef
    error: (res) => console.warn('error', res),
  });
};

export const handleLoadMore = () => {
  const loadMore = $('#js-load-more');
  loadMore.on('click', (e) => {
    const displayedItems = $('#js-results .js-result-item:not(.hidden)').length;
    if (displayedItems < 20) {
      clientLoadMore({ button: e.target, withAjax: true, increment: 5, listId: 'js-results' });
    } else {
      serverLoadMore(displayedItems);
    }
  });
};
